import { render, staticRenderFns } from "./PpvModalFooter.vue?vue&type=template&id=e37349f8&scoped=true"
import script from "./PpvModalFooter.vue?vue&type=script&lang=js"
export * from "./PpvModalFooter.vue?vue&type=script&lang=js"
import style0 from "./PpvModalFooter.vue?vue&type=style&index=0&id=e37349f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e37349f8",
  null
  
)

export default component.exports